import { AccountType } from '@/data/usecases/account/account-type'
import { DocumentModel } from '@/domain/models/document/document-model'
import { AccountWithCustomProperties } from '@/presentation/contexts/auth/account-provider'

export namespace AccountAnonymous {
  export const ID = 'anonymous'
  export const Model: Readonly<AccountWithCustomProperties> = {
    id: ID,
    name: '',
    displayName: '',
    email: '',
    document: DocumentModel.create(null),
    accountType: AccountType.Enum.ANONYMOUS,
    onboardingCompleted: false,
    onboardingCompletedAt: null,
    roles: [],
    company: {
      id: 0,
      uniqueId: '',
      name: '',
      singleSignOnOptions: [
        {
          providerName: '',
          required: false
        }
      ],
      contentRestrictions: {
        categories: []
      },
      requiresApproval: false,
      allowUpgrade: false,
      allowDependents: false,
      emailValidationRequired: false,
      phoneValidationRequired: false
    },
    preferenceLanguage: '',
    helpCenterConfig: {
      companyId: '',
      hasChatBot: false,
      hasLink: false,
      redirectTo: '',
      hasWhatsApp: false,
      whatsappPhone: ''
    }
  }
}
